import { render, staticRenderFns } from "./ReceiptTable.vue?vue&type=template&id=40d033f0&"
import script from "./ReceiptTable.vue?vue&type=script&lang=ts&"
export * from "./ReceiptTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports